var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.458,
    height: 31.455,
    viewBox: "0 0 31.458 31.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment-method",
    transform: "translate(0 -0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M107.34,372.017v4.871c2.775.122,1.974.613,6.8,2.783a4.569,4.569,0,0,0,3.554-.06h0l9.484-3.4a2.06,2.06,0,0,0,1.251-2.563c-.718-1.68-2.565-.979-2.72-.929l-4.952,1.369",
    transform: "translate(-100.745 -349.138)",
    fill: "#eac092"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(6.595 19.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M112.943,325.16l5.514,1.747a1.812,1.812,0,0,0,2.238-1.247h0a1.988,1.988,0,0,0-1.387-2.373l-4.892-1.66a4.158,4.158,0,0,0-3.531-1.706,4.453,4.453,0,0,0-3.544,2.38v2.218",
    transform: "translate(-107.341 -319.921)",
    fill: "#fedbab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M153.364,385.086a.6.6,0,0,1-.12-.012.593.593,0,0,1-.116-.035.619.619,0,0,1-.106-.057.6.6,0,0,1-.17-.17.568.568,0,0,1-.057-.106.578.578,0,0,1-.035-.115.59.59,0,0,1,0-.24.6.6,0,0,1,.035-.116.606.606,0,0,1,.226-.275.623.623,0,0,1,.106-.057.6.6,0,0,1,.116-.035.606.606,0,0,1,.24,0,.579.579,0,0,1,.115.035.606.606,0,0,1,.106.057.6.6,0,0,1,.17.17.623.623,0,0,1,.057.106.641.641,0,0,1,.035.116.59.59,0,0,1,0,.24.621.621,0,0,1-.035.115.607.607,0,0,1-.057.106.6.6,0,0,1-.17.17.606.606,0,0,1-.106.057.575.575,0,0,1-.115.035A.6.6,0,0,1,153.364,385.086Z",
    transform: "translate(-143.365 -360.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 2.328,
    height: 6.601,
    transform: "translate(4.268 21.98)",
    fill: "#eaecf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 3.653,
    height: 7.747,
    transform: "translate(0.614 21.98)",
    fill: "#3688c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M28.263,315.148l-.007-.018a2.555,2.555,0,0,0-3.461-1.276l-4.281,1.184a2.806,2.806,0,0,0-1.738-1.711l-.016-.006-4.705-1.6a4.853,4.853,0,0,0-3.915-1.8,4.913,4.913,0,0,0-3.838,2.3H.614a.614.614,0,0,0-.614.614v7.746a.614.614,0,0,0,.614.614H4.268a.614.614,0,0,0,.614-.614v-.531H6.6a.614.614,0,0,0,.614-.614v-.177a4.356,4.356,0,0,1,2.244.805,37.177,37.177,0,0,0,3.691,1.885l.027.011a5.515,5.515,0,0,0,1.977.373,4.9,4.9,0,0,0,2.036-.436l9.461-3.388.05-.02A2.622,2.622,0,0,0,28.263,315.148ZM3.653,319.97H1.229v-6.518H3.653Zm2.328-1.145h-1.1v-5.373h1.1ZM26.2,317.366l-9.457,3.386-.028.011-.025.011a3.982,3.982,0,0,1-3.06.052A35.589,35.589,0,0,1,10.068,319a5.53,5.53,0,0,0-2.858-.972v-4.949a3.8,3.8,0,0,1,2.929-1.932,3.545,3.545,0,0,1,3.008,1.413.615.615,0,0,0,.326.26l4.883,1.657a1.379,1.379,0,0,1,1,1.627,1.2,1.2,0,0,1-1.471.826l-5.5-1.744a.614.614,0,0,0-.371,1.171l5.514,1.747.018.005a2.412,2.412,0,0,0,1.844-.214,2.41,2.41,0,0,0,1.153-1.456q.021-.075.038-.149l4.613-1.278c.666-.228,1.541-.31,1.93.587C27.524,316.657,26.477,317.236,26.2,317.366Z",
    transform: "translate(0 -290.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M52.028,15.48l-5.457-5.457-6.842,6.842L51.421,28.556,57.877,22.1",
    transform: "translate(-37.288 -9.385)",
    fill: "#26cfad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M146.236,113.956h0v0a2.888,2.888,0,1,0,3.085,2.954",
    transform: "translate(-134.727 -106.929)",
    fill: "#ffd36c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M202.7,33.311V28.439c-2.775-.122-1.974-.613-6.8-2.783a4.569,4.569,0,0,0-3.554.06h0l-2.862,1.025,2.953,2.953",
    transform: "translate(-177.841 -23.745)",
    fill: "#eac092"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(2.441 0.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M39.729,85.948l2.32-2.32a3.284,3.284,0,0,1,0,4.639Z",
    transform: "translate(-39.729 -79.106)",
    fill: "#00b192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M192.264,259.26a3.284,3.284,0,0,1,4.639,0l-2.32,2.32Z",
    transform: "translate(-182.892 -243.046)",
    fill: "#00b192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M113.333,12.343l2.32-2.32,2.32,2.32A3.284,3.284,0,0,1,113.333,12.343Z",
    transform: "translate(-108.811 -10.023)",
    fill: "#00b192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M288.2,182.048a3.284,3.284,0,0,0,.763,3.442l1.934-1.934",
    transform: "translate(-272.753 -171.479)",
    fill: "#00b192"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(11.44 5.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M194.012,94.4,188.5,92.655a1.811,1.811,0,0,0-2.238,1.247h0a1.988,1.988,0,0,0,1.387,2.373l4.894,1.661h0a4.158,4.158,0,0,0,3.531,1.706,4.453,4.453,0,0,0,3.544-2.38V95.043",
    transform: "translate(-186.19 -92.585)",
    fill: "#fedbab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M339.864,124.727a.606.606,0,0,1-.12-.012.622.622,0,0,1-.115-.035.606.606,0,0,1-.106-.057.6.6,0,0,1-.17-.17.605.605,0,0,1-.057-.106.579.579,0,0,1-.035-.115.591.591,0,0,1,0-.24.6.6,0,0,1,.035-.116.622.622,0,0,1,.057-.106.6.6,0,0,1,.17-.17.607.607,0,0,1,.106-.057.577.577,0,0,1,.115-.035.612.612,0,0,1,.355.035.625.625,0,0,1,.106.057.615.615,0,0,1,.226.275.6.6,0,0,1,.036.116.62.62,0,0,1,0,.24.58.58,0,0,1-.036.115.567.567,0,0,1-.057.106.6.6,0,0,1-.17.17.624.624,0,0,1-.106.057.652.652,0,0,1-.115.035A.617.617,0,0,1,339.864,124.727Z",
    transform: "translate(-318.406 -115.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 2.328,
    height: 6.601,
    transform: "translate(24.863 3.864)",
    fill: "#eaecf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 3.653,
    height: 7.747,
    transform: "translate(27.19 2.719)",
    fill: "#3688c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M58.71,2.1H55.057a.614.614,0,0,0-.614.614v.53H52.729a.614.614,0,0,0-.614.614V4.04a4.356,4.356,0,0,1-2.244-.805A37.178,37.178,0,0,0,46.179,1.35l-.027-.011A5.227,5.227,0,0,0,42.14,1.4l-2.472.885L37.584.2a.614.614,0,0,0-.869,0L29.873,7.045a.609.609,0,0,0,0,.869L41.564,19.606a.664.664,0,0,0,.869,0l6.246-6.246c.162.014.331.022.506.022a4.913,4.913,0,0,0,3.837-2.3H58.71a.614.614,0,0,0,.614-.614V2.719A.614.614,0,0,0,58.71,2.1Zm-20,5.7a2.72,2.72,0,0,0,1.841,2.174l.016.006,1.229.417a2.274,2.274,0,1,1-3.086-2.6Zm1.229-2.4a2.408,2.408,0,0,0-1,1.057A3.5,3.5,0,1,0,42.962,10.8l2.075.7a3.923,3.923,0,0,0,.651,3.114l-1.4,1.4a3.9,3.9,0,0,0-4.571,0L33.462,9.765a3.9,3.9,0,0,0,0-4.571l1.4-1.4a3.9,3.9,0,0,0,4.571,0l1.329,1.329A2.425,2.425,0,0,0,39.937,5.4Zm6.636,8.325a2.687,2.687,0,0,1-.393-1.278,4.777,4.777,0,0,0,1.084.587ZM37.149,1.507l1.4,1.4a2.679,2.679,0,0,1-2.8,0ZM32.577,6.079a2.679,2.679,0,0,1,0,2.8l-1.4-1.4ZM42,18.3l-1.4-1.4a2.675,2.675,0,0,1,2.8,0Zm7.186-6.15a4.472,4.472,0,0,1-.641-.045h0a3.519,3.519,0,0,1-2.276-1.245c-.013-.018-.066-.088-.074-.1a.612.612,0,0,0-.339-.282L40.969,8.821a1.379,1.379,0,0,1-1-1.626h0v0a1.2,1.2,0,0,1,1.47-.824l5.5,1.744a.614.614,0,0,0,.371-1.171L42.935,5.554,42.9,5.516h0L40.629,3.248l1.948-.7.021-.008.006,0,.025-.011a3.982,3.982,0,0,1,3.06-.052A35.591,35.591,0,0,1,49.257,4.3a5.529,5.529,0,0,0,2.858.972V10.22A3.794,3.794,0,0,1,49.185,12.152Zm4.158-7.674h1.1V9.85h-1.1ZM58.1,9.85H55.671V3.333H58.1Z",
    transform: "translate(-27.866)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.779f9d73c55a30ae08c94001e0759b01.svg";
export { ForwardRef as ReactComponent };